// extracted by mini-css-extract-plugin
module.exports = {"container":"SimilarJob_container__1wl52","side":"SimilarJob_side__2R1xx","line":"SimilarJob_line___18mf"};